/* eslint-disable no-shadow */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Compressor from "compressorjs";
import {
  faTimes,
  faImages,
  faUpload,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { submitUpdate } from "../../../actions/agencyProfileActions";
import Warning from "./Warning";
import {
  Wrapper,
  CloseButton,
  FileSizeError,
  ImagesWrapper,
  Image,
  ImagePlaceholder,
  Preview,
  PrevButton,
  NextButton,
  Form,
  Actions,
  Action,
  UploadInputWrapper,
  UploadInput,
  UploadButton,
  SaveButton,
} from "./styles/images-edit-styles";

export class ImagesEdit extends Component {
  constructor(props) {
    super(props);
    const { slides } = this.props;

    this.state = {
      warningActive: false,
      slides,
      slideToUpload: null,
      saveAllowed: false,
      maxSlides: 1,
      activeSlide: 0,
      displayFileSizeError: false,
    };
  }

  toggleWarning = () => {
    this.setState(({ warningActive }) => ({ warningActive: !warningActive }));
  };

  handleUploadAction = (e, activeSlide) => {
    const { slides } = this.state;
    const newImageUrl = URL.createObjectURL(e.target.files[0]);
    const fiveMegabytes = 5000000;
    const imageTooLarge = e.target.files[0].size > fiveMegabytes;

    this.setState({
      slides: slides.map((slide) => {
        if (slide.id === activeSlide) {
          return {
            ...slide,
            url: newImageUrl,
          };
        }
        return slide;
      }),
      saveAllowed: !imageTooLarge,
      displayFileSizeError: imageTooLarge,
      slideToUpload: e.target.files[0],
    });
  };

  handlePrevButton = () => {
    this.setState(({ activeSlide }) => ({ activeSlide: activeSlide - 1 }));
  };

  handleNextButton = () => {
    this.setState(({ activeSlide }) => ({ activeSlide: activeSlide + 1 }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { slideToUpload } = this.state;
    const { toggleEditImages, submitUpdate, userId } = this.props;

    const filename = slideToUpload.name;
    /* eslint-disable no-new */
    new Compressor(slideToUpload, {
      quality: 0.8,
      maxHeight: 800,
      minHeight: 340,
      success(result) {
        const reader = new FileReader();
        reader.readAsDataURL(result);
        reader.onload = () => {
          submitUpdate(
            { profileImage: { data: reader.result, filename }, userId },
            toggleEditImages,
            "PROFILE_IMAGE"
          );
        };
      },
    });
    /* eslint-enable no-new */
  };

  render() {
    const { toggleEditImages } = this.props;
    const {
      warningActive,
      slides,
      saveAllowed,
      activeSlide,
      maxSlides,
      displayFileSizeError,
    } = this.state;

    return (
      <Wrapper>
        {warningActive && (
          <Warning
            toggleWarning={this.toggleWarning}
            closeForm={toggleEditImages}
          />
        )}
        <Form>
          <ImagesWrapper>
            {slides[activeSlide].url ? (
              <Image
                data-test-id="company-image"
                src={slides[activeSlide].url}
                alt="Slide image"
              />
            ) : (
              <ImagePlaceholder>
                <FontAwesomeIcon icon={faImages} />
              </ImagePlaceholder>
            )}
            <Preview>image preview</Preview>
          </ImagesWrapper>
          {activeSlide > 0 && (
            <PrevButton onClick={this.handlePrevButton}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </PrevButton>
          )}
          {activeSlide < maxSlides - 1 && (
            <NextButton onClick={this.handleNextButton}>
              <FontAwesomeIcon icon={faChevronRight} />
            </NextButton>
          )}
          <Actions>
            <Action upload>
              <FontAwesomeIcon icon={faUpload} />
              <UploadInputWrapper>
                <UploadButton data-test-id="change-image">change</UploadButton>
                <UploadInput
                  type="file"
                  onChange={(e) => this.handleUploadAction(e, activeSlide)}
                />
              </UploadInputWrapper>
            </Action>
            {displayFileSizeError && (
              <FileSizeError>File size must be less than 5mb</FileSizeError>
            )}
            {saveAllowed && (
              <SaveButton onClick={this.handleSubmit}>save</SaveButton>
            )}
          </Actions>
        </Form>
        <CloseButton
          data-test-id="close-edit-button"
          onClick={
            saveAllowed ? () => this.toggleWarning() : () => toggleEditImages()
          }
        >
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      </Wrapper>
    );
  }
}

ImagesEdit.propTypes = {
  submitUpdate: PropTypes.func.isRequired,
  toggleEditImages: PropTypes.func.isRequired,
  slides: PropTypes.arrayOf(PropTypes.shape({})),
  userId: PropTypes.string.isRequired,
};

ImagesEdit.defaultProps = {
  slides: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  slides: state.agencyProfile.profileData.slides,
  userId: state.agencyProfile.profileData.user.id,
});

export default connect(mapStateToProps, { submitUpdate })(ImagesEdit);
